import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=4892579f&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=4892579f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4892579f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4892579f')) {
      api.createRecord('4892579f', component.options)
    } else {
      api.reload('4892579f', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=4892579f&scoped=true&", function () {
      api.rerender('4892579f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/campaign/Edit.vue"
export default component.exports